/* eslint-disable import/prefer-default-export */
export const TOI_LIVE_DOMAIN = 'https://timesofindia.indiatimes.com';
export const TOI_S2S_LIVE_DOMAIN =
  'https://s2sorigintimesofindia.timesofindia.co.in';
export const TOI_TOICRI_LIVE_DOMAIN =
  'https://toicri.timesofindia.indiatimes.com';
export const TOI_S2S_LIVE_MOBILE_DOMAIN =
  'https://s2soriginspm.timesofindia.co.in';
export const TOI_LIVE_MOBILE_DOMAIN = 'https://m.timesofindia.com';
export const TOI_DEV_DOMAIN = 'https://toidev.indiatimes.com';
export const TOI_DEV_MOBILE_DOMAIN = 'https://spmdev.indiatimes.com';
export const TOI_IMAGE_DOMAIN = 'https://static.toiimg.com';
export const TOI_FEED_DOMAIN = 'https://toibnews.timesofindia.indiatimes.com';
export const TOI_HTE_DOMAIN = 'https://hte.timesofindia.com';
export const TOI_SEO_DOMAIN = 'https://timesofindia.indiatimes.com';
export const TOI_SITE_NAME = 'The Times Of India';
export const GOOGLE_WEBCACHE_DOMAIN = 'webcache.googleusercontent.com';
export const GENDER_SUBSCRIBE_COOKIE = 'gendernlsubscription';
export const GEOAPI_URL = __PROD__
  ? 'https://geoapi.indiatimes.com/?cb'
  : 'https://toidev.indiatimes.com/geoinc.cms';
export const POPUP_MANAGER_LOADED = 'popUpManagerLoaded';
export const ACTIVE_PRIME_USER_PRC_ARR = [1, 3, 4, 5, 8];
export const DEAULT_PAID_POINTS_SUBSCRIPTION = 200;
export const JARVIS_FEED_URL = `https://jarvis.indiatimes.com/v1/feeds`;
export const JARVIS_PVT_FEED_URL =
  'https://vsp1jarvispvt.indiatimes.com/v1/feeds';
export const JARVIS_CACHE_BY_PASS = 'cache_policy=cache_by_pass';
export const ABOUND_BACKEND_SERVICE_DOMAIN = __PROD__
  ? 'https://services.timesofindia.com'
  : 'https://nprelease.indiatimes.com';
export const COMMENT_API_DOMAIN = 'https://plus.timesofindia.com';
export const PRC_PRIME_API =
  'https://nprelease.indiatimes.com/prime-auth/prime/status/setCookies';
export const CMS_CLOUD_SERVING_DOMAIN = __PROD__
  ? 'https://cloudservices.indiatimes.com/'
  : 'https://cloudservicesstg.indiatimes.com/';
export const CMS_API = 'cms-api';

export const PRC_FOR_NEVER_REGISTER = 0; // 0, -1 or not present  - Never register with prime
export const PRC_FOR_FTU = 1; // 1 = Free Trial Active
export const PRC_FOR_FT_EXPIRED = 2; // 2 = Free Trial Expired
export const PRC_FOR_FTA_PAYMENT = 3; // 3 = free trial and payment
export const PRC_FOR_FT_PAYMENT_EXPIRED = 4; // 4 = Free Trial with payment expired
export const PRC_FOR_SUBSCRIBED = 5; // Subscription or Paid User
export const PRC_FOR_SUBSCRIPTION_EXPIRED = 6; // Subscription expired
export const PRC_FOR_SUBSCRIPTION_CANCELLED = 7; // 7 = Subscription cancelled
export const PRC_FOR_SUBSCRIPTION_AUTORENEW = 8; // 8 = Subscription Auto - Renewal
export const PRC_FOR_NOT_LOGIN = -1; // not login
export const PRC_FOR_GRACE = 'grace'; // grace period active
export const STAGING_URL_PREFIX = '/intarnel'; // every URLL on staging will be prefix by this
export const STAGING_URL_PREFIX2 = '/internal'; // every URLL on staging will be prefix by this
export const FREE_ARTICLE_PRIME_ID = '500';
export const PAID_ARTICLE_PRIME_ID = '100';
export const FREE_ARTICLE_PRIME_ID_NUMBER = 500;
export const PAID_ARTICLE_PRIME_ID_NUMBER = 100;
export const CURRENT_PAGE = 1;
export const IMAGE_URL = 'https://static.toiimg.com/photo/';
export const IMAGE_VERSION = {
  version: '1',
};
export const VIDEO_TIMESTAMP_THRESHOLD = 1451500200000; // 31st dec 2015 TOIPR-90328
export const ELECTION_STATUS_MAPPING = {
  3: 'won',
  1: 'leading',
  2: 'trailing',
  4: 'lost',
};
export const ELECTION_NEWS_LISTING_PAGES = [
  '/elections/lok-sabha-constituencies',
  '/elections/candidates',
  '/elections/results',
  '/elections/lok-sabha/states',
  '/elections/lok-sabha-elections/parties',
  '/elections/exit-polls',
  '/elections/star-candidates',
  '/elections/lok-sabha-election-schedule',
  '/elections/news',
  '/elections/modi-meter',
];

export const TOI_VIDEO_API_KEY = 'toiamp5t9tCpb7nb5q6jUb';
export const ETIMES_VIDEO_API_KEY = 'toi371googleamp5asdo9u9gg';

export const PRIMESCREEN_STORAGE_NAME = {
  TopBand: {
    DISMISS: 'tbpdsn',
    CTACLICK: 'tbsf',
    SESSIONNAME: 'tbsc',
  },
  Toast: 'primeVideoToolTip',
};
export const CONGRATS_POPUP_STORAGE_NAME = 'congrats_popup';
export const ALREADY_PRIME_USER_STORAGE_NAME = 'already_prime_user';
export const PLAN_ACTION = 'planAction';
export const DOWNLOAD_APP_POPUP_STORAGE_NAME = 'download_app_popup';
export const BACK_BUTTON_LISTING_STORAGE_NAME = 'back_button_activated';
export const LOGIN_MAPPED_ON_LIVE = false;
export const AB_TESTING_LIVEBLOG_AD_REPLACEMENT = 'KdSO35O7RIewQr9HpQ3BIg';
export const ACTIVITY_MAXCAP_MAP = 'allActivityConfig';
export const ACTIVITY_ACCRUE_MAP = 'achievedActConfig';
export const ETIMES_SUBSCRIBE_COOKIE = 'etimes_subscribe';
// export const GENDER_SUBSCRIBE_COOKIE = 'gendernlsubscription';
export const AB_TESTING_OPEN_APP_EXPERIMENT_KEY = 'wyAKtbB7Q8e836hHBGJnag';
//export const AB_TESTING_ARTICLESHOW_CONTROL_GROUP_PERCENT = 25;
//export const AB_TESTING_ARTICLESHOW_RANGE = 75;

export const MOB_DEFAULT_INTERSTITIAL_URL_PROD =
  'https://m.timesofindia.com/elections/defaultinterstitial_js_react/minify-1,v-5.cms';
export const MOB_DEFAULT_INTERSTITIAL_URL_DEV =
  'https://spmdev.timesofindia.com/elections/defaultinterstitial_js_react/minify-1,v-5.cms';
export const MOB_DEFAULT_INTERSTITIAL_US_URL_PROD =
  'https://m.timesofindia.com/elections/defaultinterstitial_js_react_us_hp/minify-1,v-2.cms';
export const MOB_DEFAULT_INTERSTITIAL_US_URL_DEV =
  'https://spmdev.timesofindia.com/elections/defaultinterstitial_js_react_us_hp/minify-1,v-2.cms';
export const dimensionMapping = {
  dimension1: 'journalistName',
  dimension2: 'optimizelyTOICheck',
  dimension3: 'articleId',
  dimension4: 'authorName',
  dimension5: 'agency',
  dimension6: 'contentType',
  dimension7: 'clientId',
  dimension8: 'section',
  dimension9: 'template',
  dimension10: 'primeStatus',
  dimension11: 'paytmWidget',
  dimension12: 'evergreenStory',
  dimension13: 'network',
  dimension14: 'hpv2WAP',
  dimension15: 'perpetualArticle',
  dimension16: 'city',
  dimension17: 'language',
  dimension18: 'toiPlusPlug',
  dimension19: 'loginSource',
  dimension20: 'featurePhone',
  dimension21: 'loginstatus',
  dimension22: 'userId',
  dimension23: 'covid19',
  dimension25: '__gaabtest',
  dimension33: 'planeName',
  dimension34: 'nudgeType',
  dimension35: 'subjectLine',
  dimension38: 'currencyCode',
  dimension50: 'orderId',
  dimension31: 'msid',
  dimension51: 'expiryTime',
  dimension52: 'graceExpiryTime',
  dimension53: 'purchaseType',
  dimension82: 'userCityFromGeo',
  dimension55: 'userState',
  dimension56: 'userCountryCode',
  dimension58: 'primeStory',
  dimension59: 'subsection',
  dimension60: 'storyNatureOfContent',
  dimension61: 'storyTopicTree',
  dimension62: 'platform',
  dimension63: 'deviceManufacturer',
  dimension64: 'deviceModel',
  dimension65: 'deviceCategory',
  dimension66: 'storyPublishedAt',
  dimension67: 'storyLastUpdatedAt',
  dimension68: 'storyAgency',
  dimension69: 'liveBlogProductName',
  dimension70: 'contentType',
  dimension71: 'onPlatformSource',
  dimension72: 'source',
  dimension73: 'signalEventType',
  dimension74: 'denmarkFolderId',
  dimension75: 'title',
  dimension76: 'storySection',
  dimension77: 'storySubSection',
  dimension78: 'storyTemplate',
  dimension79: 'osVersion',
  dimension80: 'osFamily',
  dimension81: 'userLoginStatus',
  dimension83: 'user_ptns_score',
  dimension84: 'user_ptns_algorithm_name',
  dimension85: 'cookie_ttl_second',
  dimension54: 'signals_category',
  dimension43: 'signals_destination',
};

export const IPL_MID_ARTICLE = 'ipl_mid_article';
export const BANNER_MID_ARTICLE = 'banner_mid_article';
export const PROMOTED_AMAZON_SLIDER = 'Amazon_sponsored';
export const YEAR_IN_DAYS = 365;
export const TWO_YEAR_IN_DAYS = 730;
export const ONE_MONTH = 30;
export const PAID = 'PAID';
export const TOI_PLUS = 'TOI_PLUS';

export const Plan = {
  PAY_PER_STORY: '1',
  DEFAULT_PLAN: '2',
  CRED: '3',
};

export const GEO_CODE_MAPPINNG = {
  1: 'IN',
};

export const SLIKE_ADVIDEO_SECTIONS = [
  'ASTROLOGY',
  'BUSINESS',
  'SIDEBAR_LISTING',
  'MINITV',
  'ARTICLESHOW',
  'TOP-TENNIS-VIDEOS',
  'MINITV_STICKY',
];
export const SPOTLIGHT_RHS_WDGTMAP = ['MEDIAWIRE', 'BRANDWIRE'];
export const ETIMES_SUBSCRIBE = {
  ENT:
    'https://timesofindia.indiatimes.com/newsletter/addsubscription/?status=1&adHoc=true&scheduletime=1&day=1&frequency=1&secName=All_Entertainment&secId=1081479906&nlid=1006&id=',
  TV:
    'https://timesofindia.indiatimes.com/newsletter/addsubscription/?status=1&adHoc=true&scheduletime=1&day=6&frequency=2&nlid=1018&id=',
  WEB_SERIES:
    'https://timesofindia.indiatimes.com/newsletter/addsubscription/?status=1&adHoc=true&scheduletime=2&day=6&frequency=2&nlid=1003&id=',
  LIFESTYLE:
    'https://timesofindia.indiatimes.com/newsletter/addsubscription/?status=1&adHoc=true&scheduletime=1&day=1&frequency=1&nlid=1004&id=',
};

export const slikeVPEvents = {
  _splVideoLoaded: 'onVideoLoaded',
  splVideoStarted: 'onVideoStarted',
  splVideoCompleted: 'onVideoCompleted',
  splVideoPaused: 'onVideoPauded',
  splVideoResumed: 'onVideoResumed',
  _splError: 'onError',
  splAdRequest: 'onAdRequest',
  splAdLoaded: 'onAdLoaded',
  splAdComplete: 'onAdComplete',
  splAdSkip: 'onAdSkip',
  splAdView: 'onAdView',
  splVideoFullscreenchange: 'onVideoFullscreenchange',
  splVolumeChange: 'onVolumeChange',
  splInit: 'onVideoReady',
  splAdError: 'onAdError',
};

export const videoEventsMap = {
  onVideoRequest: 'VIDEOREQUEST',
  onVideoLoadRequest: 'VIDEOLOADREQUEST',
  onVideoReady: 'VIDEOREADY',
  onVideoStarted: 'VIDEOVIEW',
  onVideoCompleted: 'VIDEOCOMPLETE',
  onAdRequest: 'ADREQUEST',
  onAdLoaded: 'ADLOADED',
  onAdComplete: 'ADCOMPLETE',
  onAdSkip: 'ADSKIP',
  onAdView: 'ADVIEW',
  onAdError: 'ADERROR',
  onVolumeChange: 'AUDIOPLAY',
  onVideoFullscreenchange: 'FULLSCREEN_ON',
  onError: 'ERROR',
  //VIDEOAUTOPLAY_TOGGLE: To Do : Need to check which spl events is linked to it
  //DIM_TOGGLE: To Do : Need to check which spl events is linked to it
};

export const NP_DOMAIN = __PROD__
  ? 'https://npcoins.indiatimes.com'
  : 'https://nprelease.indiatimes.com';

export const TOI_UTILS_DOMAIN = __PROD__
  ? 'https://toiutils.indiatimes.com'
  : 'https://nprelease.indiatimes.com';

export const UNIFIED_FEED_DOMAIN = __PROD__
  ? 'https://global-feed.indiatimes.com'
  : 'https://nprelease.indiatimes.com';

export const UNIFIED_FEED_DOMAIN_GLOBAL = __PROD__
  ? 'https://services.timesofindia.com'
  : 'https://stg-global-feed.indiatimes.com';

export const UNIFIED_FEED_DOMAIN_SERVICE = __PROD__
  ? 'https://services.timesofindia.com'
  : 'https://nprelease.indiatimes.com';

export const UNIFIED_VIDEO_DOMAIN_SERVICE = __PROD__
  ? 'https://global-feed.indiatimes.com/wufs/feed/list/video'
  : 'https://nprelease.indiatimes.com/wufs/feed/list/video';

export const UNIFIED_FEED_RESOURCES_DOMAIN = __PROD__
  ? 'https://resources.timesofindia.com/prod'
  : 'https://resources.timesofindia.com/stage';

export const SUBSCRIPTION_STAGE_DOMAIN =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com'
    : 'https://stgsubs.timesofindia.com';

export const SUBSCRIPTION_LINKING_DOMAIN_GOOGLE =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subscriptions.economictimes.indiatimes.com'
    : 'https://qcsubscription.economictimes.indiatimes.com';

export const SUBSCRIPTION_AUTH_STAGE_DOMAIN =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://pauth.indiatimes.com'
    : 'https://stgpauth.indiatimes.com';

export const PRC_PRIME_API_DESKTOP =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://pauth.indiatimes.com/prime-auth/prime/status/setCookies'
    : 'https://stgpauth.indiatimes.com/prime-auth/prime/status/setCookies';

export const PRC_PRIME_API_MOB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://pauth.timesofindia.com/prime-auth/prime/status/setCookies'
    : 'https://stgpauth.timesofindia.com/prime-auth/prime/status/setCookies';

export const TOI_SUBS_PLAN_STATUS_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://pauth.indiatimes.com/prime-auth/web/prime/status?rspBody=true&version=3'
    : 'https://stgpauth.indiatimes.com/prime-auth/web/prime/status?rspBody=true&version=3';
export const TOI_SUBS_PLAN_STATUS_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://pauth.indiatimes.com/prime-auth/mweb/prime/status?rspBody=true&version=3'
    : 'https://stgpauth.indiatimes.com/prime-auth/mweb/prime/status?rspBody=true&version=3';

export const TOI_SUBS_PLAN_STATUS_WEB_V2 =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://oauth.economictimes.indiatimes.com/auth/TOI/userToken?grantType=refresh_token'
    : 'https://qa-oauth.economictimes.indiatimes.com/auth/TOI/userToken?grantType=refresh_token';

export const TOI_SUBS_PLAN_STATUS_MWEB_V2 =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://oauth.economictimes.indiatimes.com/auth/TOI/userToken?grantType=refresh_token'
    : 'https://qa-oauth.economictimes.indiatimes.com/auth/TOI/userToken?grantType=refresh_token';

export const TOI_SUBS_FETCH_ORDER_STATUS_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/subscriptions/order/web/fetch'
    : 'https://stgsubs.timesofindia.com/subscriptions/order/web/fetch';
export const TOI_SUBS_FETCH_ORDER_STATUS_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/subscriptions/order/mweb/fetch'
    : 'https://stgsubs.timesofindia.com/subscriptions/order/mweb/fetch';

export const TOI_SUBS_FETCH_PLAN_STATUS_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://pauth.indiatimes.com/prime-auth/web/prime/status?version=2'
    : 'https://stgpauth.indiatimes.com/prime-auth/web/prime/status?version=2';

export const TOI_SUBS_FETCH_PLAN_STATUS_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://pauth.indiatimes.com/prime-auth/mweb/prime/status?version=2'
    : 'https://stgpauth.indiatimes.com/prime-auth/mweb/prime/status?version=2';

export const TOI_SUBS_FETCH_PLANS_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/plan-manager/subscription/web/fetch?fv=1100'
    : 'https://stgsubs.timesofindia.com/plan-manager/subscription/web/fetch?fv=1100';
export const TOI_SUBS_FETCH_PLANS_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/plan-manager/subscription/mweb/fetch?fv=1100'
    : 'https://stgsubs.timesofindia.com/plan-manager/subscription/mweb/fetch?fv=1100';

export const TOI_SUBS_CREATE_ORDER_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/subscriptions/order/web/create?fv=1100'
    : 'https://stgsubs.timesofindia.com/subscriptions/order/web/create?fv=1100';
export const TOI_SUBS_CREATE_ORDER_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/subscriptions/order/mweb/create?fv=1100'
    : 'https://stgsubs.timesofindia.com/subscriptions/order/mweb/create?fv=1100';

export const TOI_SUBS_INITIATE_JUSPAY_SDK_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/subscriptions/order/web/initiate?fv=1100'
    : 'https://stgsubs.timesofindia.com/subscriptions/order/web/initiate?fv=1100';

export const TOI_SUBS_INITIATE_JUSPAY_SDK_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://subs.timesofindia.com/subscriptions/order/mweb/initiate?fv=1100'
    : 'https://stgsubs.timesofindia.com/subscriptions/order/mweb/initiate?fv=1100';

export const TOI_PLUS_PLAN_TRANSLATION_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://plus.timesofindia.com/toi-feed/config/toiw/trans/toiplusnudges?lang=1&fv=1100&theme=light'
    : 'https://nprelease.indiatimes.com/toi-feed/config/toiw/trans/toiplusnudges?lang=1&fv=1100&theme=light';

export const TOI_PLUS_PLAN_TRANSLATION_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://plus.timesofindia.com/toi-feed/config/toim/trans/toiplusnudges?lang=1&fv=1100&theme=light'
    : 'https://nprelease.indiatimes.com/toi-feed/config/toim/trans/toiplusnudges?lang=1&fv=1100&theme=light';

export const TOI_SUBS_PLAN_TRANSLATION_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://plus.timesofindia.com/toi-feed/config/toiw/trans/planpage?lang=1&fv=1100&theme=light'
    : 'https://nprelease.indiatimes.com/toi-feed/config/toiw/trans/planpage?lang=1&fv=1100&theme=light';

export const TOI_SUBS_PLAN_TRANSLATION_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://plus.timesofindia.com/toi-feed/config/toim/trans/planpage?lang=1&fv=1100&theme=light'
    : 'https://nprelease.indiatimes.com/toi-feed/config/toim/trans/planpage?lang=1&fv=1100&theme=light';

export const TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://plus.timesofindia.com/toi-feed/config/toiw/trans/commonnudge?lang=1&fv=1100&theme=light'
    : 'https://nprelease.indiatimes.com/toi-feed/config/toiw/trans/commonnudge?lang=1&fv=1100&theme=light';

export const TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://plus.timesofindia.com/toi-feed/config/toim/trans/commonnudge?lang=1&fv=1100&theme=light'
    : 'https://nprelease.indiatimes.com/toi-feed/config/toim/trans/commonnudge?lang=1&fv=1100&theme=light';

export const TOI_PLUS_CONFIG_DOMAIN =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? 'https://plus.timesofindia.com'
    : 'https://nprelease.indiatimes.com';

export const TOI_PLUS_ENABLING_CONDITIONS_API_WEB = `${TOI_PLUS_CONFIG_DOMAIN}/toi-feed/config/toiw/trans/master?fv=1100`;

export const TOI_PLUS_ENABLING_CONDITIONS_API_MWEB = `${TOI_PLUS_CONFIG_DOMAIN}/toi-feed/config/toim/trans/master?fv=1100`;

export const TOI_PLUS_CHECK_USER_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? `https://subs.timesofindia.com/subscriptions/user-account/web/findUser`
    : `https://stgsubs.timesofindia.com/subscriptions/user-account/web/findUser`;

export const TOI_PLUS_CHECK_USER_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? `https://subs.timesofindia.com/subscriptions/user-account/mweb/findUser`
    : `https://stgsubs.timesofindia.com/subscriptions/user-account/mweb/findUser`;

// export const TOI_PLUS_HOMEPAGE_CARDCMS_LITE_URL = __PROD__
//   ? 'https://api-newscard.indiatimes.com/card-inserts/web/toi-plus_lite.json'
//   : 'https://cards-staging.indiatimes.com/card-inserts/web/toi-plus_lite.json';

// export const TOI_PLUS_HOMEPAGE_CARDCMS_URL = __PROD__
//   ? 'https://api-newscard.indiatimes.com/card-inserts/web/toi-plus.json'
//   : 'https://cards-staging.indiatimes.com/card-inserts/web/toi-plus.json';

export const LOGIN_CHECK_USER_WEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? `https://subs.timesofindia.com/subscriptions/user-account/web/fetchUserMobile?syncWithSSO=true`
    : `https://stgsubs.timesofindia.com/subscriptions/user-account/web/fetchUserMobile?syncWithSSO=true`;

export const LOGIN_CHECK_USER_MWEB =
  LOGIN_MAPPED_ON_LIVE || __PROD__
    ? `https://subs.timesofindia.com/subscriptions/user-account/mweb/fetchUserMobile?syncWithSSO=true`
    : `https://stgsubs.timesofindia.com/subscriptions/user-account/mweb/fetchUserMobile?syncWithSSO=true`;

export const SUBSCRIPTION_PROD_DOMAIN = 'https://subs.timesofindia.com';
export const WEB_INDIA_HP_GA_CAT = 'WEB-IN-NHP1';
export const WAP_INDIA_HP_GA_CAT = 'MWEB-IN-NHP1';
export const WAP_INLINE_TOIPLUS_GA_CAT = 'WAP-IN-NHP1';
export const GENDER_PLUS_SUBSCRIBE =
  'https://timesofindia.indiatimes.com/newsletter/addsubscription/?frequency=2&scheduletime=1&status=1&nlid=1039&adHoc=true&day=6&hostid=83&id=';

export const EXIT_POLL_FEED_URL =
  'https://toibnews.timesofindia.indiatimes.com/electionfeed/comdec2023/exit_json.htm';
export const EXIT_POLL_PR_AL_FEED_URL =
  'https://toibnews.timesofindia.indiatimes.com/electionfeed/comdec2023/pr_al_pg_json.htm';
export const EXIT_POLL_STAR_CND_FEED_URL =
  'https://toibnews.timesofindia.indiatimes.com/electionfeed/comdec2023/star_json.htm';

export const PR_AL_FEED_URL =
  'https://toibnews.timesofindia.indiatimes.com/electionfeed/comdec2023/pr_al_pg_json.htm';
export const STAR_CND_FEED_URL =
  'https://toibnews.timesofindia.indiatimes.com/electionfeed/comdec2023/star_json.htm';

export const ELECTION_EXTRA_INFO_URL =
  '/electionwidget_extratext.cms?feedtype=sjson';

export const COVID_NL_COOKIE = 'covid19nlsubscription';

export const CORONAVIRUS_GA_CATEGORY = 'coronavirus_new';
export const EXPLAINERS_GA_CATEGORY = 'WEB-AL-Explainers';

export const NEWSLISTING_NL_COOKIE = 'newslistingsubscription';
export const NEWSLISTING_GA_CATEGORY = '-AL-city-';
// export const CORONAVIRUS_CARDS_HOME_LITE_JSON_URL = __PROD__
//   ? 'https://api-newscard.indiatimes.com/card-inserts/web/homepage_lite.json'
//   : 'https://cards-staging.indiatimes.com/card-inserts/web/homepage_lite.json';

export const CARDS_ARTICLESHOW_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/article-show/'
  : 'https://cards-staging.indiatimes.com/article-show/';
export const CROSSWORD_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/toi/post/cards/587602/content.json'
  : 'https://cards-staging.indiatimes.com/toi/post/cards/9501/content.json';

export const CARDS_ARTICLESHOW_JSON_URL_V2 = __PROD__
  ? 'https://api-signals.indiatimes.com/api/toi-plus/v2/recommendation/stories/article.json'
  : 'https://vsp1api-signals.indiatimes.com/api/toi-plus/v2/recommendation/stories/article.json';
// BOAAS-399 : Depricated APIS
// export const CARDS_ARTICLESHOW_JSON_URL_V2_LITE = __PROD__
//   ? 'https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json?mode=cards'
//   : 'https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json?mode=cards';
// export const CARDS_ARTICLESHOW_JSON_URL_V2_PERPETUAL_LITE = __PROD__
//   ? 'https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json'
//   : 'https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json';
// This can be removed once we have removed old read next(Newscard) from code
// export const PERSONALIZE_READ_NEXT_V2 = __PROD__
//   ? `https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next.json`
//   : `https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next.json`;
// export const READ_NEXT_V2_LITE = __PROD__
//   ? `https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json?mode=data`
//   : `https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json?mode=data`;
// ends here
// export const PERSONALIZE_READ_NEXT_V2_API = __PROD__
//   ? `https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next.json`
//   : `https://api-signals-staging.indiatimes.com/api/toi/v3/personalize/read-next.json`;
// export const PERSONALIZE_READ_NEXT_V2_API_DEFAULT = __PROD__
//   ? `https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json`
//   : `https://api-signals.indiatimes.com/api/toi/v3/personalize/read-next/default.json`;

export const PERSONALIZE_UP_NEXT_V2_API = __PROD__
  ? 'https://api-signals.indiatimes.com/api/toi/v3/personalize/up-next.json'
  : 'https://api-signals.indiatimes.com/api/toi/v3/personalize/up-next.json';

export const USER_PROPENSITY_API = __PROD__
  ? `https://api-signals.indiatimes.com/api/toi/v3/j/propensity-to-not-subscribe`
  : `https://api-signals-staging.indiatimes.com/api/toi/v3/j/propensity-to-not-subscribe`;
export const PERSONALIZE_UP_NEXT_V2_API_DEFAULT = __PROD__
  ? 'https://api-signals.indiatimes.com/api/toi/v3/personalize/up-next/default.json'
  : 'https://api-signals-staging.indiatimes.com/api/toi/v3/personalize/up-next/default.json';

export const CARDS_TOPIC_TREE_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/topic-tree/story-bundle/web'
  : 'https://cards-staging.indiatimes.com/topic-tree/story-bundle/web';

export const CARDS_TOPIC_TREE_STORY_BUNDLE_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/topic-tree/story-bundle'
  : 'https://cards-staging.indiatimes.com/topic-tree/story-bundle';

export const CORONAVIRUS_CARDS_HOME_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/card-inserts/web/homepage.json'
  : 'https://cards-staging.indiatimes.com/card-inserts/web/homepage.json';

export const CORONAVIRUS_CARDS_HOME_US_LITE_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/card-inserts/web/us_lite.json'
  : 'https://cards-staging.indiatimes.com/card-inserts/web/us_lite.json';

export const CORONAVIRUS_CARDS_HOME_US_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/card-inserts/web/us.json'
  : 'https://cards-staging.indiatimes.com/card-inserts/web/us.json';

export const TOI_HOMEPAGE_CARDCMS_LITE_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/card-inserts/web/homepage_lite.json'
  : 'https://cards-staging.indiatimes.com/card-inserts/web/homepage_lite.json';

export const TOI_HOMEPAGE_CARDCMS_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/card-inserts/web/homepage.json'
  : 'https://cards-staging.indiatimes.com/card-inserts/web/homepage.json';

// export const DEFAULT_UTILITY_BELT_API = __PROD__
//   ? `https://api-signals.indiatimes.com/api/toi/v3/personalize/utilitybelt/default.json?client=browser`
//   : `https://api-signals-staging.indiatimes.com/api/toi/v3/personalize/utilitybelt/default.json?client=browser`;

// export const UTILITY_BELT_API = __PROD__
//   ? `https://api-signals.indiatimes.com/api/toi/v3/personalize/utilitybelt.json?client=browser&template=listing-page`
//   : `https://api-signals.indiatimes.com/api/toi/v3/personalize/utilitybelt.json?client=browser&template=listing-page`;

// Personalize api starts
export const getPersonalizeApi = platform =>
  __PROD__
    ? `https://api-signals.indiatimes.com/api/toi/v3/j/${platform}-web/articleshow.json`
    : `https://api-signals-staging.indiatimes.com/api/toi/v3/j/${platform}-web/articleshow.json`;

export const getClientDefaultApi = platform =>
  __PROD__
    ? `https://api-signals.indiatimes.com/api/toi/v3/j/${platform}-web/articleshow-csdefault.json`
    : `https://api-signals-staging.indiatimes.com/api/toi/v3/j/${platform}-web/articleshow-csdefault.json`;

export const getServerSideApi = platform =>
  __PROD__
    ? `https://api-signals.indiatimes.com/api/toi/v3/j/${platform}-web/articleshow-ssdefault.json`
    : `https://api-signals-staging.indiatimes.com/api/toi/v3/j/${platform}-web/articleshow-ssdefault.json`;

// Personalize api ends

export const ENT_CITY_LIST_API =
  '/etimes_city_popup_feed_spadata.cms?feedtype=sjson';
export const ENT_CITY_TO_STATE_API =
  '/etimes_city_popup_feed_spadata.cms?feedtype=sjson&reqtype=citytostate&city_name=';
export const ENT_SEARCH_API = '/etimes/etsearchnewfeedspadata.cms?bycity=';
export const GEO_CITY_BY_LAT_LONG_API = `${ENT_CITY_LIST_API}`;

export const TOI_GEO_CITY_BY_LAT_LONG_API = __PROD__
  ? 'https://timesofindia.indiatimes.com/toi_city_gps_feed_spadata.cms?feedtype=sjson'
  : 'https://toidev.indiatimes.com/toi_city_gps_feed_spadata.cms?feedtype=sjson';

export const CORONAVIRUS_GRAPHS_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/card-inserts/web/coronavirus.json'
  : 'https://cards-staging.indiatimes.com/card-inserts/web/coronavirus.json';
export const OLYMPICS_CARDS_HOME_LITE_JSON_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/card-inserts/web/sports/tokyo-olympics-2021_lite.json'
  : 'https://cards-staging.indiatimes.com/card-inserts/web/sports/tokyo-olympics-2021_lite.json';

export const GET_US_SURVEY_QUESTION_LIST =
  'https://survey.indiatimes.com/times-survey/survey/question/getQList?accesskey=cfcd208495d565ef66e7dff9f98764da&surveyid=735';

export const POST_US_SURVEY_QUESTION_LIST =
  'https://survey.indiatimes.com/times-survey/survey/opinion/insert';

export const MAX_SURVEY_SHOW_LIMIT = 3;

export const US_SURVEY_COUNT = 'usSurveyCount';

export const US_SURVEY_SUBMITTED = 5;

const TIMES_CLUB_URL = 'https://timesofindia.indiatimes.com/abound';
const TIMES_CLUB_MWEB_URL = 'https://offers.timesclub.co';

export const TIMES_CLUB_RHS_CTA = `${TIMES_CLUB_URL}?utm_source=TOI_web&utm_medium=TCpromo&utm_campaign=TC_rhs`;
export const TIMESCLUB_WIDGET_CTA_URLS = {
  MWEB: `${TIMES_CLUB_MWEB_URL}?utm_source=TOI_mweb&utm_medium=TCpromo&utm_campaign=TC_popup`,
  WEB: `${TIMES_CLUB_URL}?utm_source=TOI_web&utm_medium=TCpromo&utm_campaign=TC_popup`,
};
export const TIMESCLUB_CTA_CAROUSEL = `https://timesclub.app.link/explore`;
export const TIMESCLUB_CTA_NAV = `https://timesclub.app.link/abound`;

export const TOI_PLUS_SUBSCRIBE_COOKIE = 'toiplusSubscribeClose';
export const CLMB_WEB_CID = '2658:3';
export const CLMB_MWEB_CID = '2658:39';
export const E_CLMB_WEB_CID = '65615:2608';
export const E_CLMB_MWEB_CID = '65615:2609';
export const TOPIC_API = __PROD__
  ? 'https://toifeeds.indiatimes.com/treact/feeds/toi/web/show/topic?path=/topic/'
  : 'https://pwastg.timesofindia.com/feeds/toi/web/show/topic?path=/topic/';
export const ETIMES_TOPIC_API = __PROD__
  ? 'https://toifeeds.indiatimes.com/treact/feeds/etimes/web/show/topic?path=/topic/'
  : 'https://pwastg.timesofindia.com/feeds/etimes/web/show/topic?path=/topic/';

export const LIVE_SCORE_CARD_API = __PROD__
  ? 'https://toifeeds.indiatimes.com/treact/feeds/toi/web/cricket_score?status=live'
  : 'https://pwastg.timesofindia.com/feeds/toi/web/cricket_score?status=live';
export const NEWSLETTER_SUBSCRIPTION_API_ORIGIN = __PROD__
  ? 'https://etsub3.indiatimes.com/'
  : 'https://etmailstg.indiatimes.com/';
export const NEWSLETTER_SUBSCRIPTION_API = __PROD__
  ? 'https://etsub3.indiatimes.com/et-mailing-subscription/ok/subscription/5f5a00075651d4e45e1b67c6  '
  : 'https://etmailstg.indiatimes.com/et-mailing-subscription/ok/subscription/5f5a00075651d4e45e1b67c6';
export const TOI_PLUS_PLAN_PAGE_URL = '/toi-plus/plans';
export const WEB_TOPIC_GA_CATEGORY = 'WEB-TOI-Topic';
export const WAP_TOPIC_GA_CATEGORY = 'WAP-TOI-Topic';
export const NEWSLETTER_DEFAULT_VAL = [
  {
    serviceId: '67c67ef5a2c16a7780fb8da4',
    userPreference: {
      periodicalFrequency: 'DAILY',
      dayScheduleSlot: 'MORNING',
    },
  },
  {
    serviceId: '6824c923f27cc3302dfb8da3',
    userPreference: {
      periodicalFrequency: 'DAILY',
      dayScheduleSlot: 'MORNING',
    },
  },
  {
    serviceId: '68761f22016e0f5808fb8da2',
    userPreference: {
      periodicalFrequency: 'DAILY',
      dayScheduleSlot: 'MORNING',
    },
  },
  {
    serviceId: '68680605593ac79ae7fb8da3',
    userPreference: {
      periodicalFrequency: 'DAILY',
      dayScheduleSlot: 'MORNING',
    },
  },
];
export const TOI_COLLAPSED_ARTICLE_WORDS_LIMIT = 60;
export const GET_SELECTED_TOPIC_TAB = () => {
  const tabElem = document.getElementById('topic_tab');
  const seledTabElem = tabElem
    ? tabElem.getElementsByClassName('active')
    : undefined;
  return seledTabElem && seledTabElem.length ? seledTabElem[0].value : '';
};
export const MEDLY_IMG_PATH = __PROD__
  ? 'https://static.toiimg.com/imagenext/medley-topic/thumb/topics/image/show/83/'
  : 'https://imagestg.indiatimes.com/imagenext/medley-topic/thumb/topics/image/show/83/';

export const ELECTION_TOP_TREND_API = __PROD__
  ? 'https://timesofindia.indiatimes.com/mobile_xml_feed_news_list.cms?msid=95271818&tag=articlelistroot&perpage=10&feedtype=sjson'
  : 'https://toidev.indiatimes.com/mobile_xml_feed_news_list.cms?msid=95271818&tag=articlelistroot&perpage=10&feedtype=sjson';

export const SEARCH_TOP_TREND_API = __PROD__
  ? 'https://timesofindia.indiatimes.com/mobile_xml_feed_news_list.cms?msid=7137896&tag=articlelistroot&perpage=10&feedtype=sjson'
  : 'https://toidev.indiatimes.com/mobile_xml_feed_news_list.cms?msid=7137896&tag=articlelistroot&perpage=10&feedtype=sjson';

export const SEARCH_OVERLAY_IDLE_TIME = __PROD__ ? 60000 * 5 : 60000 * 1;
export const OPEN_SEARCH_COOKIE = 'isSearchBarShown';
export const OPEN_SEARCH_EXPIERY_DAYS = 5;

export const CITY_LIST_DATA_URL = __PROD__
  ? 'https://timesofindia.indiatimes.com/feeds/web_navigation_feed_spadata.cms?category=city&feedtype=sjson&reqfrm=city&default_city=city'
  : 'https://toidev.indiatimes.com/feeds/web_navigation_feed_spadata.cms?category=city&feedtype=sjson&reqfrm=city&default_city=city';

export const ZEB_PAY_URL =
  'https://zebpay.com/in/register/?utm_source=TOI_Integration&utm_medium=Banners+and+Icons&utm_campaign=ZebPay_Awareness_TOI_Integration';

export const FONT_SIZE = 'fs';

export const TEMPLATE_NAME_FOR_TOIP_FREE_ARTCILE = 'prime_as_noblocker';
export const TEMPLATE_NAME_FOR_TOIP_PAID_ARTCILE = 'prime_as';
export const FIVE_MINUTES = '300';
export const SIX_HOURS = '21600';
export const TIMES_PRIME_SAVING_API = __PROD__
  ? 'https://api.timesprime.com/prime/external/updateTOISavings'
  : 'https://test-ext.timesprime.com/prime/external/updateTOISavings';

export const HP_CTN_300X250_AD = '207114';
export const TOI_DOMAIN = __PROD__
  ? 'https://timesofindia.indiatimes.com/'
  : 'https://toidev.indiatimes.com/';

// eslint-disable-next-line no-nested-ternary
export const AFFILIATES_SDK_URL = __PROD__
  ? 'https://assets.toiimg.com/affiliates/sdk/v1.js'
  : 'https://assets.toiimg.com/affiliates/sdk/staging/v1.js';
// 'http://localhost:8080/v1.js';

export const AFFILIATES_SDK_URL_V2 = __PROD__
  ? 'https://assets.toiimg.com/affiliates/sdk/v2.js'
  : 'https://assets.toiimg.com/affiliates/sdk/staging/v2.js';

export const SIGNAL_EVENT_TYPES = {
  share: 'share',
  comment: 'comment',
  articleRead: 'Article Show Scroll Depth',
};

export const SIGNAL_EVENT_NAMES = {
  share: 'share',
  comment: 'comment',
  articleRead: 'Article Show Scroll Depth',
};
// export const AFFILIATES_SDK_URL = 'http://localhost:8080/v1.js';

export const apiKeyMweb = 'toimweb5t9tCpb7nb5q6jUb';
export const apiKeyWeb = 'toiweba5ec9705eb7ac2c984033e061';
export const APRTICLE_POLL_CATEGORY = 'Reactions On Articles';

export const REACT_URL = __PROD__
  ? 'https://api-signals.indiatimes.com/api/toi/preferences/v1/react.json'
  : 'https://vsp1api-signals.indiatimes.com/api/toi/preferences/v1/react.json';

export const HAS_REACTED_URL = __PROD__
  ? 'https://api-signals.indiatimes.com/api/toi/preferences/v1/has-reacted.json'
  : 'https://vsp1api-signals.indiatimes.com/api/toi/preferences/v1/has-reacted.json';

export const MYTIMES_LOGO =
  'https://static.toiimg.com/thumb/msid-96009984/96009984.jpg';
export const MYTIMES_LOGO_WITH_INFO =
  'https://static.toiimg.com/thumb/msid-96027472/96027472.jpg';

export const ARTICLESHOW = 'articleshow';

export const dimensionObj = [
  dimensionMapping.contentGroup1,
  dimensionMapping.dimension4,
  dimensionMapping.dimension5,
  dimensionMapping.dimension8,
  dimensionMapping.dimension9,
  dimensionMapping.dimension11,
  dimensionMapping.dimension23,
  dimensionMapping.dimension35,
  'dimension26',
  'dimension27',
  'dimension39',
  'dimension40',
  'dimension41',
  'dimension42',
];

export const CD_TYPE_GA = 'ga';
export const CD_TYPE_GRX = 'grx';
export const CD_TYPE_GA_AND_GRX = 'gaAndGrx';

export const SIGNAL_PARAMETER = '&v=1';
export const PROPENSITY_PARAMETER = `&v=${Date.now()}`;
export const READ_NEXT_CONFIG_API = __PROD__
  ? 'https://timesofindia.indiatimes.com/feed/feed_readnstonoff.cms?feedtype=json'
  : 'https://toidev.indiatimes.com/feed/feed_readnstonoff.cms?feedtype=json';
export const RETIREMENT_CALCULATOR_TEXT = '#Retirement Calculator#';
export const GRXID_ABSENT_ERROR_CODE = '998';
export const GRXID_ABSENT_ERROR_MESSAGE = 'GRX ID is missing from GRX SDK';
// export const PERSONALISE_API_DOWN_MESSAGE =
//   'API unresolved by the time user scrolled to the widget';
// export const PERSONALISE_API_DOWN_CODE = '995';
export const PERSONALISE_API_DOWN_CODE = '500';
export const PERSONALISE_API_DOWN_MESSAGE = '500 error';
export const PERSONALISE_API_EMPTY_RESPONSE_MESSAGE = 'no_MSID_returned_by_API';
export const TOIPLUS_SHOWN_FROM_DENMARK_API = 'toi+ shown from Denmark API';
export const TOIPLUS_SHOWN_FROM_DENMARK_API_CODE = 200;
export const DENMARK_API_FAILED = 'Denmark API Failed';
export const DENMARK_API_FAILED_CODE = 479;
export const MPULSE_MOBILE_TOKEN = 'HKUCR-4GJUW-DPKFB-KHWX8-7NXM9';
export const MPULSE_WEB_TOKEN = 'UBWPJ-TVLRK-LYZZ3-88H95-6ZX6Y';
export const TIMER_CANCELLED_BY_USER = 'Timer Cancelled by user';
export const NETWORK_ERROR = 'Network Error';

export const GSTFORMGETDATA = __PROD__
  ? 'https://subs.timesofindia.com/subscriptions/user-address/'
  : 'https://stgsubs.timesofindia.com/subscriptions/user-address/';

export const GSTFORM_PINCODEDATA = 'https://api.postalpincode.in/pincode/';

export const TWITTER_EMBED_SCRIPT = 'https://platform.twitter.com/widgets.js';
export const INSTAGRAM_EMBED_SCRIPT = 'https://www.instagram.com/embed.js';
export const SEE_OFFERS = 'See Offers';
export const TOIPLUSARTICLESHOWTEMPLATE = 'prime_as';
export const ARTICLESHOWTEMPLATE = 'articleshow';
export const TIMES_SPECIAL_NOC_NAME = 'times-special';

// grx properties
export const grxGlobalValues = [
  'deviceManufacturer',
  'deviceModel',
  'osVersion',
  'osFamily',
  'userState',
  'userCountryCode',
  'userId',
  'primeStatus',
  'storyPublishedAt',
  'storyLastUpdatedAt',
  'primeStory',
  'url',
];
export const getNonGlobalGrxValue = () => {
  let nonGlobalGrxValue = [];
  Object.keys(dimensionMapping).forEach(dimension => {
    const grxVal = dimensionMapping[dimension];
    if (!grxGlobalValues.includes(grxVal)) {
      nonGlobalGrxValue.push(grxVal);
    }
  });
  nonGlobalGrxValue = [
    ...nonGlobalGrxValue,
    'dimension26',
    'dimension27',
    'dimension39',
    'dimension40',
    'dimension41',
    'dimension42',
  ];
  return nonGlobalGrxValue;
};

export const DEFAULT_GRX_NOT_AVAILABLE = 'Not Available';
export const DEFAULT_GRX_STORYPUBLISHED_UPDATED_VALUE = 946684800000;
export const TOI_ONE_LINK_JS =
  'https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js';
export const TOI_INSTAGRAM_EMBED_JS = 'https://www.instagram.com/embed.js';
export const TOI_PROMISE_CALLBACK_SCRIPTS = [TOI_ONE_LINK_JS];

export const PAGE_LEVEL_PERSONALIZE_API_TYPE = {
  SERVER_DEFAULT: 'SERVER_DEFAULT',
  CLIENT_DEFAULT: 'CLIENT_DEFAULT',
  PERSONALIZED: 'PERSONALIZED',
};

export const PERSONALISE_SPINNER =
  'https://static.toiimg.com/thumb/imgsize-2614228,msid-100765547,width-80,resizemode-4/100765547.jpg';
export const PERSONALISE_TICK =
  'https://static.toiimg.com/thumb/imgsize-2614228,msid-100697932,width-80,resizemode-4/100697932.jpg';

export const TOIP_NL_LANDING_PAGE_DATA_URL = __PROD__
  ? 'https://tnl.indiatimes.com/newsletter/config/'
  : 'https://toiutils.indiatimes.com/newsletter/config/';

export const TOIP_NL_USER_DATA_URL = __PROD__
  ? 'https://tnl.indiatimes.com/newsletter/user/newsletters/fetch'
  : 'https://toiutils.indiatimes.com/newsletter/user/newsletters/fetch';

export const TOIP_NL_SUBS_UNSUBS_URL = __PROD__
  ? 'https://tnl.indiatimes.com/newsletter/user/toia/toi-plus/bulk/sub-unsub'
  : 'https://toiutils.indiatimes.com/newsletter/user/toia/toi-plus/bulk/sub-unsub';

export const TOI_EPAPER_URL_WEB =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://epaper.indiatimes.com/timesepaper/publication-the-times-of-india,city-delhi.cms?redirectionSource=TOIWeb'
    : 'https://etdev8243.indiatimes.com/timesepaper/publication-the-times-of-india,city-delhi.cms?redirectionSource=TOIWeb';

export const TOI_EPAPER_URL_MWEB =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://epaper.indiatimes.com/timesepaper/publication-the-times-of-india,city-delhi.cms?redirectionSource=TOIWeb'
    : 'https://spmdev8243.economictimes.com/timesepaper/publication-the-times-of-india,city-delhi.cms?redirectionSource=TOIWeb';

export const addEmailJsso =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://jsso.indiatimes.com/sso/identity/profile/edit?channel=toi&intent=addemail'
    : 'https://jssostg.indiatimes.com/sso/identity/profile/edit?channel=toi&intent=addemail';

export const ET_DOMAIN = 'epaper.indiatimes.com';

export const ET_DOMAIN_WEB =
  __PROD__ || LOGIN_MAPPED_ON_LIVE ? ET_DOMAIN : 'etdev8243.indiatimes.com';
export const ET_DOMAIN_MWEB =
  __PROD__ || LOGIN_MAPPED_ON_LIVE ? ET_DOMAIN : 'spmdev8243.economictimes.com';

export const TOI_X_CLIENT_ID_WEB =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'b2a8e883ec676f417520f422068a4742'
    : 'w2a8e883ec676f417520f422068a4741';

export const TOI_X_CLIENT_ID_WAP =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'w6590a0af0377c711dede6bd565f27c2'
    : 'w2a8e883ec676f417520f422068a4741';

export const TOI_X_SITE_APP_CODE =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? '04e2b3dc222d26d7ffa0ed3d3285cce6'
    : '7a3514a35e5493b739659ba1bb9ea0a9';

export const ET_SUBSCRIPTION_STATUS =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://subscriptions.economictimes.indiatimes.com'
    : 'https://testsubscription.economictimes.indiatimes.com';

export const NEW_PLANPAGE_URL =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://buy.indiatimes.com/TOI/plans'
    : 'https://dev-buy.indiatimes.com/TOI/plans';

export const MY_SUBSCRIPTION_PAGE_URL =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://buy.indiatimes.com/TOI/mysubscription'
    : 'https://dev-buy.indiatimes.com/TOI/mysubscription';

export const REDEEM_BENEFITS_PAGE_URL =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://buy.indiatimes.com/TOI/complimentary'
    : 'https://dev-buy.indiatimes.com/TOI/complimentary';

export const READ_NEXT_PLACEHOLDER = {
  WEB:
    'https://static.toiimg.com/thumb/imgsize-12345,msid-103928268,width-600,resizemode-4/103928268.jpg',
  MWEB:
    'https://static.toiimg.com/thumb/imgsize-12345,msid-103928272,width-600,resizemode-4/103928272.jpg',
};

// For Topic Pages
export const TOPIC_CARD_TYPE = {
  BOOKS: 'books',
  FILMOGRAPHY: 'filmography',
  CELEBSCARDS: 'celebscards',
};

export const VIEW_ALL = 'View All';

export const GA_PUSH_DATA_API =
  __PROD__ || LOGIN_MAPPED_ON_LIVE
    ? 'https://etpwaapi.economictimes.com/pushGaData'
    : 'https://etpwaapipre.economictimes.com/pushGaData';
export const REVIEWS_LIVE_DOMAIN = 'https://reviews.indiatimes.com';
export const REVIEWS_STAG_DOMAIN = 'https://toireviewsstg.indiatimes.com';
export const MOBILE_PLATFORM = 'mweb';
export const DESKTOP_PLATFORM = 'web';
export const WEBVIEW_PLATFORM = 'webview';
export const BUSINESS_TOI = 'toi';
export const BUSINESS_ETIMES = 'etimes';
export const CAN_RENEW_SUBSCRIPTION = 'can_renew_subscription';
export const CAN_BUY_SUBSCRIPTION = 'can_buy_subscription';

export const FORMULAE_PLAYLIST_ID = __PROD__
  ? 'abd10adf-7ac2-4d71-a000-94bb9ad6cc1b'
  : '484661f3-47e4-4362-a98e-a34241498a12';

export const TOIP_PLANPAGE_FEATURE_CODE_CTA_NUDGE = 'TOIADF';
export const TOIP_PLANPAGE_FEATURE_CODE_OFFER_BANNER = 'TOIARTCL';
export const TIMES_HEALTH_URL =
  'https://timeshealthplus.com/TH/plans?acqSource=TOI_homepagebanner_paid&acqSubSource=homepagebanner_top_paid&utm_source=TOI_paid&utm_medium=homepage_top_paid&utm_campaign=homepage_top_banner';
export const TIMES_HEALTH_IMG =
  'https://static.toiimg.com/photo/imgsize-12345,msid-121910093/121910093.jpg';
